module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-hengshui.f11c27ae.png";